export interface IChartRange {
  min: number
  max: number
}

export type ReportPeriods = 'daily' | 'weekly' | 'monthly' | 'yearly'
